import React, { FC, useCallback } from 'react';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  setDeletingWordsListError, deleteWordsList,
} from '../../slice/actions';
import {
  getDeletingWordsListError,
  getIsDeletingWordsList,
} from '../../slice/selectors';
import classes from './DeleteWordsListModal.module.less';
import AppModal, { ModalButtons } from '../../../../components/AppModal';
import { success, error } from '../../../../components/Message';
import Text from '../../../../components/Text';
import useActionStatus from '../../../../hooks/useActionStatus';
import { setActiveList } from '../../../auth/slice/actions';
import { fetchFolderTreeWithLists } from '../../../folders/slice/actions';

type DeleteWordsListModalProps = {
  wordsList: { id: number, name: string };
  hideModal: () => void;
};

const DeleteWordsListModal: FC<DeleteWordsListModalProps> = ({ wordsList, hideModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoading = useSelector(getIsDeletingWordsList);
  const apiError = useSelector(getDeletingWordsListError);

  const onSuccess = useCallback(() => {
    success(t('words-list:delete.messages.success'));
    hideModal();
  }, [hideModal, t]);

  const onError = useCallback(() => {
    error(t('words-list:delete.messages.failure'));
  }, [t]);

  useActionStatus(onSuccess, onError, {
    isLoadingSelector: getIsDeletingWordsList,
    errorSelector: getDeletingWordsListError,
  });

  // const onClick = useCallback(() => {
  //   if (wordsList && wordsList.id) {
  //     dispatch(deleteWordsList(wordsList.id));
  //     dispatch(setActiveList(null));
  //   }
  // }, [dispatch, wordsList]);

  const onClick = useCallback(async () => {
    if (wordsList && wordsList.id) {
      try {
        dispatch(deleteWordsList(wordsList.id));
        dispatch(setActiveList(null));

        // ✅ DODAJ refresh:
        dispatch(fetchFolderTreeWithLists(true));
      } catch (err) {
        console.error('Error deleting list:', err);
      }
    }
  }, [dispatch, wordsList]);

  const onCancel = useCallback(() => {
    dispatch(setDeletingWordsListError(null));
    hideModal();
  }, [dispatch, hideModal]);

  return wordsList && (
    <AppModal title={t('words-list:delete.title')} visible={Boolean(wordsList)} onCancel={onCancel}>
      <Text className={classes.description}>{t('words-list:delete.description')}</Text>
      <ModalButtons>
        <Button
          // type="ghost"
          onClick={onCancel}
          disabled={isLoading}
        >
          {t('words-list:delete.cancel')}
        </Button>
        <Button
          type="primary"
          danger
          onClick={onClick}
          disabled={isLoading}
          loading={isLoading}
        >
          {t('words-list:delete.submit')}
        </Button>
      </ModalButtons>
      {apiError && <div>{apiError.message}</div>}
    </AppModal>
  );
};

export default DeleteWordsListModal;
